import { type RefObject, useEffect, useMemo, useState } from 'react';

type UseIsInViewportProps = {
	ref: RefObject<HTMLElement>;
};

export const useInViewport = ({
	ref,
}: UseIsInViewportProps): {
	hasBeenInViewport: boolean;
} => {
	const [hasBeenInViewport, setHasBeenInViewport] = useState(false);

	const observer = useMemo(
		() =>
			new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setHasBeenInViewport(entry.isIntersecting);
					}
				},
				{
					rootMargin: '0px 0px 200px 0px',
				},
			),
		[],
	);

	useEffect(() => {
		if (ref.current) {
			observer.observe(ref.current);
			return () => observer.disconnect();
		}
	}, [observer, ref]);

	return {
		hasBeenInViewport,
	};
};
